import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';

import { AuthProvider } from '@/lib/auth';
import ProtectedRoute from '@/components/ProtectedRoute';
import AppShell from '@/components/AppShell';
import { Toaster } from '@/components/ui/sonner';

import LoginPage from '@/pages/Login';
import DashboardPage from '@/pages/Dashboard';
import CompaniesPage from '@/pages/Companies';
import CompanySettingsPage from '@/pages/CompanySettings';
import RecruitmentPage from '@/pages/Recruitment';
import OnboardingPage from '@/pages/Onboarding';
import PoliciesPage from '@/pages/Policies';
import TrainingPage from '@/pages/Training';
import OffboardingPage from '@/pages/Offboarding';
import PayrollPage from '@/pages/Payroll';
import PayslipPrintPage from '@/pages/PayslipPrint';
import BankReportPrintPage from '@/pages/BankReportPrint';
import CalendarPage from '@/pages/Calendar';
import JobsPage from '@/pages/Jobs';
import AnalyticsPage from '@/pages/Analytics';
import AdminUsersPage from '@/pages/AdminUsers';
import AdminSettingsPage from '@/pages/AdminSettings';
import AdminTransfersPage from '@/pages/AdminTransfers';
import ProfilePage from '@/pages/Profile';

function Shell({ children }) {
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/payroll/print/payslip/:runId/:employeeId" element={<ProtectedRoute><PayslipPrintPage /></ProtectedRoute>} />
          <Route path="/payroll/print/bank/:runId" element={<ProtectedRoute><BankReportPrintPage /></ProtectedRoute>} />

          <Route path="/dashboard" element={<ProtectedRoute><Shell><DashboardPage /></Shell></ProtectedRoute>} />
          <Route path="/companies" element={<ProtectedRoute><Shell><CompaniesPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/recruitment" element={<ProtectedRoute><Shell><RecruitmentPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/jobs" element={<ProtectedRoute><Shell><JobsPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/onboarding" element={<ProtectedRoute><Shell><OnboardingPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/policies" element={<ProtectedRoute><Shell><PoliciesPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/training" element={<ProtectedRoute><Shell><TrainingPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/offboarding" element={<ProtectedRoute><Shell><OffboardingPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/payroll" element={<ProtectedRoute><Shell><PayrollPage /></Shell></ProtectedRoute>} />
          <Route path="/companies/:companyId/settings" element={<ProtectedRoute><Shell><CompanySettingsPage /></Shell></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Shell><AnalyticsPage /></Shell></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute><Shell><CalendarPage /></Shell></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute adminOnly><Shell><AdminUsersPage /></Shell></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute adminOnly><Shell><AdminSettingsPage /></Shell></ProtectedRoute>} />
          <Route path="/admin/transfers" element={<ProtectedRoute><Shell><AdminTransfersPage /></Shell></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Shell><ProfilePage /></Shell></ProtectedRoute>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
